import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';

import { colors } from '../../styles';
import Form from '../../components/Forms/Form';

const styles = css`
  padding: 0 0 70px;
  @media(min-width: 992px) {
    padding: 100px 0;
  }

  .ContentSection_body {
    font-weight: 300;
    font-size: 15px;
    color: ${colors.color3};
    letter-spacing: 0;
    line-height: 28px;
    @media(min-width: 992px) {
      font-size: 17px;
      color: ${colors.text};
      line-height: 30px;
    }
    b {
      font-weight: 700;
    }
    a {
      font-weight: 700;
    }
  }
  .container {
    margin: 0 auto;
  }
  .form-col-fluid {
    margin-bottom: 30px;
  }
  .resources_title {
    padding-bottom: 15px;
    border-bottom: 1px solid #b9b9b9;
  }
  .warrantyRequest_interactive {
    align-items: center;
    margin: 0 auto;
  }
  .warrantyRequest_graphic {
      position: relative;
      width: 600px !important;
      height: 600px !important;
      border: 0;
      margin: 0 auto;
      display: block;
      transform: scale(.5, .5) translate(-45%, -50%);
      @media (min-width: 600px) {
        transform: none;
      }
    }
  .WelcomeSection_btn a {
    color: #ffffff;
  }
  #warrantyGraphic h2 {
    @media(min-width: 992px) {
      font-size: 42px;
    }
  }
`;

function ContentSection({ content, widget }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-5 pr-lg-4 mt-4 mt-lg-0">
            <div className="ContentSection_body mb-5 mb-lg-0" dangerouslySetInnerHTML={SanitizeHtml(get(content, 'body_copy'))} />
            <h4 className="mt-5 resources_title">Additional Resources</h4>
            <ul className="resources_list list-unstyled">
              {
                get(content, 'additional_resources', []).map(item => (
                  <a
                    href={item.resource_doc.contentUrl}
                    target="_blank"
                    rel="naopener noreferrer"
                    key={item.resource_title}
                  >
                    <li className="resources_name my-3">{item.resource_title}</li>
                  </a>
                ))
              }
            </ul>
            <div role="button" tabIndex={0} className="WelcomeSection_btn mb-5">
              <a href="#warrantyGraphic">
                Interactive Home
              </a>
            </div>
          </div>
          <div className="col-lg-7 px-4">
            <Form
              formName="warrantyRequest"
              formLabel="Warranty Request"
              thankYou={get(content, 'thank_you_body')}
              fields={[
                {
                  type: 'Text',
                  label: 'First Name',
                  className: 'form-col',
                  field: 'firstName',
                  required: true,
                },
                {
                  type: 'Text',
                  label: 'Last Name',
                  className: 'form-col',
                  field: 'lastName',
                  required: true,
                },
                {
                  type: 'Email',
                  label: 'Email',
                  className: 'form-col',
                  field: 'email',
                  required: true,
                  requiredMessage: '',
                  invalidMessage: '',
                },
                {
                  type: 'Phone',
                  label: 'Phone',
                  className: 'form-col',
                  field: 'phone',
                  required: false,
                  requiredMessage: '',
                  invalidMessage: '',
                },
                {
                  type: 'Select',
                  label: get(widget, 'problem_location[0].title'),
                  options: [...get(widget, 'problem_location[0].list').map(item => get(item, 'item', ''))],
                  field: 'problem',
                  className: 'form-col-fluid',
                  required: true,
                },
                {
                  type: 'Select',
                  label: get(widget, 'item_to_repair[0].title'),
                  options: [...get(widget, 'item_to_repair[0].list').map(item => get(item, 'item', ''))],
                  field: 'item',
                  className: 'form-col-fluid',
                  required: true,
                },
                {
                  type: 'FileMultiple',
                  label: 'Attach Images (max 5)',
                  className: 'form-col-fluid',
                  field: 'files',
                  max: 5,
                  required: true,
                },
                {
                  type: 'TextArea',
                  label: 'Please describe the problem',
                  className: 'form-col-fluid',
                  field: 'comments',
                  required: false,
                },
              ]}
            />
          </div>
        </div>
        <div className="ScrollTarget" id="warrantyGraphic">
          <div className="row justify-content-center">
            <div className="col-xl-7">
              <h2 className="my-5 text-center">{get(content, 'interactive_house[0].title')}</h2>
              <iframe title="Home Designer" src="https://ih.2-10.com/builder/210-no-basement/" className="warrantyRequest_graphic" allowFullScreen />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ContentSection.propTypes = {
  content: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData({
  widget: 'form_options',
})(ContentSection);



// WEBPACK FOOTER //
// ./src/pages/WarrantyInformationRequest/ContentSection.js